<template>
  <div id="searchInputComponent" class="position-relative justify-content-center">

    <div class="searchSelectIcon">
      <!-- <img :src="imageLink"> -->
    </div>

    <div class="position-relative addressSearch">
      <input
          ref="inputField"
          :id="id"
          type="text"
          class="form-control text-align-center"
          :placeholder="placeHolder"
          :disabled="isDisabledInput"
          v-model="searchedValue"
          @click="openSearchModal"
      />
      <div class="position-absolute d-flex flex-column selectOptionContainer" :class="{'d-none': displayNoneClass}">
        <template v-for="location in filteredCities" :key="location.id">
          <div @click="select($event, location)" :data-item="location.address" class="selectOptionContainer__item flex flex-row align-items-center">
            <span class="selectOptionContainer__item__icon"></span>
            {{ location.address }}
          </div>
        </template>
      </div>
    </div>
    <template v-if="!message.state">
      <MessageComponent :message-class="'error-address-message'" :message="message.message"></MessageComponent>
    </template>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import type {PropType} from "vue";
import type {
  IApiResponseTransportationAddress
} from "../../interfaces/apiResponseInterfaces/IApiResponseTransportationAddress.interface";

// @ts-ignore
import MessageComponent from "../../components/message/MessageComponent.vue";


export default defineComponent({
  name: 'SearchInput',
  emits: ['get-city'],
  components: {
    MessageComponent,
  },
  props: {
    cities: {
      type: Array as PropType<IApiResponseTransportationAddress[]>
    },
    imageLink: {
      type: String,
    },
    placeHolder: {
      type: String,
      required: true
    },
    id: {
      type: String
    },
    pickupAddress: {
      type: Boolean,
      required: false,
      default: false
    },
    selectedCity: {
      type: Object as PropType<IApiResponseTransportationAddress> | null
    },
    message: {
      type: Object as PropType<{state: boolean, message: string}>,
    },
    isDisabledInput: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      searchedValue: <string|null>null,
      displayNoneClass: true,
    }
  },

  watch: {
    searchedValue(newVal) {
      if (!newVal || !newVal.length) {
        this.handleEmit({
          id: null,
          city: null,
          address: null,
          address_to_show: null
        });
      }
    }
  },

  computed: {
    filteredCities(): IApiResponseTransportationAddress[]|undefined {

      let arr: IApiResponseTransportationAddress[] = [];

      let cities = this.cities!.sort((a, b) => {
        const cityA = a.city!.toUpperCase();
        const cityB = b.city!.toUpperCase();
        if (cityA > cityB) {
          return -1;
        }
        if (cityA < cityB) {
          return 1;
        }

        return 0;
      });

      if (!this.searchedValue) {
        return cities.slice(0, 5);
      }

      if (this.searchedValue) {
        let tmp = this.searchedValue;
        tmp = this.escapeRegExp(this.searchedValue);
        let regex = new RegExp(`${tmp.trim()}`, 'gi');

        arr = cities
            .filter(el => el.address!.match(regex))
            .slice(0, 5);
      }

      return arr;
    }
  },

  methods: {
    escapeRegExp(text) {
      return text.replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&');
    },

    select(evt: Event, payload: IApiResponseTransportationAddress): void {
      this.searchedValue = (evt.target as HTMLElement).dataset.item!;
      this.handleEmit(payload);
      this.displayNoneClass = true;
    },

    handleEmit(payload: IApiResponseTransportationAddress): void {
      this.$emit('get-city', {value: payload, pickup: !! this.pickupAddress});
    },

    openSearchModal(e: Event) {
      this.displayNoneClass = true;

      if ((e.target as HTMLElement) === (this.$refs.inputField as HTMLElement)) {
        this.displayNoneClass = false;
      }
    },
  },

  mounted() {
    document.addEventListener('click', this.openSearchModal);

    if (this.selectedCity) {
      this.searchedValue = this.selectedCity.address;
    }
  },
});
</script>

<style lang="scss" scoped>
@import './search.scss';

</style>